<template>
  <v-card
    v-if="showCard"
    id="import-modal-upload-card"
    class="pb-1"
    :color="$vuetify.theme.dark ? 'dark_backgroundDarkBlue' : undefined"
  >
    <v-card-title>
      {{ $t(`views.imports.importModal.importModalUploadCard.title.${type}`) }}
    </v-card-title>

    <v-card-text class="py-0 mb-0 mt-2">
      <div class="pt-2 pb-2">
        <ApiErrorAlert ref="apiErrorAlert" :error="errorCode" />

        <p class="py-0 mb-1">
          <span class="mr-2">
            {{ $t(`views.imports.importModal.importModalUploadCard.description.${type}`) }}
          </span>
        </p>
      </div>

      <v-alert
        v-if="type === 'order'"
        :color="$vuetify.theme.dark ? 'dark_backgroundSoftBlue' : 'softInfo'"
        icon="mdi-information"
        class="pa-2 mt-1 mb-6"
      >
        {{ $t(`views.imports.importModal.importModalUploadCard.alertDividends`) }}
      </v-alert>

      <v-form>
        <v-row>
          <v-col cols="12" md="12" class="pt-0">
            <BrokerAlert
              :text="$t('views.orders.orderModal.needBroker')"
              marginClass="mt-3 mb-6"
              :brokerSearchLoading="brokerSearchLoading"
              :brokerSearchBrokers="brokerSearchBrokers"
            />
            <BrokerSearch
              v-model="myImport.broker"
              :brokers.sync="brokerSearchBrokers"
              :isLoading.sync="brokerSearchLoading"
              :disabled="loading"
              not-select-first
              @change="changeBroker"
            />
          </v-col>

          <template v-if="myImport.broker">
            <v-col cols="12" md="12" class="tabs pa-3 mt-2">
              <v-tabs v-model="importType" show-arrows background-color="transparent" height="40">
                <v-tab v-if="isValidBroker" href="#custom" active-class="v-tab-active-class">
                  {{ $t(`views.imports.importModal.importModalUploadCard.custom.title`) }}
                  ({{ myImport.broker.alias }})
                </v-tab>
                <v-tab href="#generic" active-class="v-tab-active-class">
                  {{ $t(`views.imports.importModal.importModalUploadCard.generic.title`) }}
                </v-tab>
              </v-tabs>
            </v-col>

            <v-col cols="12" md="12" class="tabs-items pt-0 pl-2">
              <v-tabs-items v-model="importType" touchless>
                <v-tab-item value="custom">
                  <!-- <v-alert
                    v-if="isBrokerInBeta"
                    :color="$vuetify.theme.dark ? 'dark_backgroundSoftBlue' : 'softInfo'"
                    icon="mdi-information"
                    class="mt-4 mx-2 py-3 pl-2 import-modal-upload-card-beta-info"
                  >
                    {{ $t(`views.imports.importModal.importModalUploadCard.betaInfo`) }}
                    <a href="https://www.filios.app/contacta" target="_blank">
                      {{ $t(`common.contactWithUs`) }}.
                    </a>
                  </v-alert> -->

                  <v-col cols="12" md="12" class="pt-2 pb-0">
                    <div class="import-modal-upload-card-instructions">
                      <h1>
                        {{
                          $t(
                            `views.imports.importModal.importModalUploadCard.custom.instructions.steps.${type}`
                          )
                        }}
                        {{ myImport.broker.name }}:
                      </h1>
                      <ol class="mb-0 mt-1">
                        <li
                          v-for="(item, key) in $t(
                            `views.imports.importModal.importModalUploadCard.custom.instructions.${myImport.broker.code}.steps.${type}`
                          )"
                          :key="key"
                        >
                          {{ item }}
                        </li>
                      </ol>
                      <p
                        v-if="
                          $te(
                            `views.imports.importModal.importModalUploadCard.custom.instructions.${myImport.broker.code}.link`
                          )
                        "
                        class="mt-2 mb-0"
                      >
                        {{
                          $t(
                            `views.imports.importModal.importModalUploadCard.custom.instructions.link`
                          )
                        }}
                        <a
                          :href="
                            $t(
                              `views.imports.importModal.importModalUploadCard.custom.instructions.${myImport.broker.code}.link`
                            )
                          "
                          target="_blank"
                        >
                          {{
                            $t(
                              `views.imports.importModal.importModalUploadCard.custom.instructions.linkhere`
                            )
                          }}
                        </a>
                        <span>
                          {{
                            $t(
                              `views.imports.importModal.importModalUploadCard.custom.instructions.linkContact`
                            )
                          }}
                        </span>
                      </p>
                    </div>
                  </v-col>
                </v-tab-item>
                <v-tab-item value="generic">
                  <v-col cols="12" md="12" class="pt-2 pb-0">
                    <div class="import-modal-upload-card-instructions">
                      <h1>
                        {{
                          $t(
                            `views.imports.importModal.importModalUploadCard.generic.instructions.steps.title.${type}`
                          )
                        }}
                      </h1>
                      <ol class="mb-0 mt-1">
                        <li>
                          {{
                            $t(
                              `views.imports.importModal.importModalUploadCard.generic.instructions.steps.ol1`
                            )
                          }}
                          <a
                            :href="
                              type === 'order'
                                ? 'https://www.filios.app/wp-content/uploads/2025/08/generic_template.csv'
                                : 'https://www.filios.app/wp-content/uploads/2025/08/generic_template_dividends.csv'
                            "
                            target="_blank"
                          >
                            {{
                              $t(
                                `views.imports.importModal.importModalUploadCard.generic.instructions.steps.ol1-link`
                              )
                            }}
                          </a>
                        </li>
                        <li>
                          {{
                            $t(
                              `views.imports.importModal.importModalUploadCard.generic.instructions.steps.ol2`
                            )
                          }}
                          <a
                            href="https://www.filios.app/blog/como-hacer-una-importacion-generica-en-filios/"
                            target="_blank"
                          >
                            {{
                              $t(
                                `views.imports.importModal.importModalUploadCard.generic.instructions.steps.ol2-link`
                              )
                            }}
                          </a>
                        </li>
                        <li>
                          {{
                            $t(
                              `views.imports.importModal.importModalUploadCard.generic.instructions.steps.ol3`
                            )
                          }}
                        </li>
                        <li>
                          {{
                            $t(
                              `views.imports.importModal.importModalUploadCard.generic.instructions.steps.ol4`
                            )
                          }}
                        </li>
                      </ol>
                    </div>
                  </v-col>
                </v-tab-item>
              </v-tabs-items>
            </v-col>

            <v-col cols="12" md="12" class="pt-1 pb-0">
              <v-file-input
                v-model="myImport.file"
                accept=".csv, application/vnd.ms-excel, .xls, .xlsx"
                show-size
                truncate-length="30"
                :disabled="loading"
                :placeholder="
                  importType === 'custom'
                    ? $t(
                        `views.imports.importModal.importModalUploadCard.custom.instructions.${myImport.broker.code}.fileLabel`
                      )
                    : $t(
                        `views.imports.importModal.importModalUploadCard.generic.instructions.fileLabel`
                      )
                "
              />
              <template v-if="fileSizeExceeded">
                <v-alert color="softError" icon="mdi-information" class="my-0 py-1">
                  <span class="mr-2">
                    {{
                      $t('views.imports.importModal.importModalUploadCard.file.fileSizeExceeded')
                    }}
                  </span>
                </v-alert>
              </template>
            </v-col>

            <template v-if="isBrokerCheckingDuplicates">
              <v-col cols="12" md="12" class="switch-option pt-0 pl-4 my-0 pb-0">
                <div class="d-flex align-end">
                  <v-switch
                    v-model="checkDuplicates"
                    :disabled="true"
                    :label="
                      $t('views.imports.importModal.importModalUploadCard.checkDuplicates.label')
                    "
                    hide-details
                    dense
                    class="mr-2 mt-1"
                    :color="$vuetify.theme.dark ? 'white' : 'softTextGrey'"
                  ></v-switch>
                  <div class="switch-option-icon">
                    <InfoIcon
                      :size="16"
                      :text="
                        $t('views.imports.importModal.importModalUploadCard.checkDuplicates.help')
                      "
                    />
                  </div>
                </div>
              </v-col>
            </template>

            <template v-if="isBrokerCreateBuysFromExternalTransfers">
              <v-col cols="12" md="12" class="switch-option pt-0 pl-4 my-0 pb-0">
                <div class="d-flex align-end">
                  <v-switch
                    v-model="createBuysFromExternalTransfers"
                    :disabled="loading"
                    :label="
                      $t(
                        'views.imports.importModal.importModalUploadCard.createBuysFromExternalTransfers.label'
                      )
                    "
                    hide-details
                    dense
                    class="mr-2 mt-1"
                    :color="$vuetify.theme.dark ? 'white' : 'softTextGrey'"
                  ></v-switch>
                  <div class="switch-option-icon">
                    <InfoIcon
                      :size="16"
                      :text="
                        $t(
                          'views.imports.importModal.importModalUploadCard.createBuysFromExternalTransfers.help'
                        )
                      "
                    />
                  </div>
                </div>
              </v-col>
            </template>
          </template>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="mt-5">
      <a class="list-mode-link ml-5" @click="$emit('goListMode')">
        {{ $t('views.imports.importModal.listMode') }}
      </a>
      <v-spacer />
      <v-btn
        class="mr-1"
        text
        :disabled="loading"
        :small="$vuetify.breakpoint.smAndDown"
        @click="$emit('close')"
      >
        {{ $t('common.cancel') }}
      </v-btn>
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="saveDisabled"
        :small="$vuetify.breakpoint.smAndDown"
        @click="importCsv"
      >
        {{ $t('views.imports.importModal.importModalUploadCard.import') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { get } from 'lodash'
import { mapState } from 'vuex'
import { importCsv } from '@/lib/api'
import {
  getSupportedBrokersForImport,
  isBrokerInBetaForImport,
  isBrokerCheckingDuplicates,
  isBrokerCreateBuysFromExternalTransfers,
} from '@/lib/brokers/brokers'
import gtag from '@/lib/gtag'
import ApiErrorAlert from '@/views/components/common/ApiErrorAlert'
import BrokerSearch from '@/views/components/common/BrokerSearch'
import BrokerAlert from '@/views/components/common/BrokerAlert'
import InfoIcon from '@/views/components/common/InfoIcon'

export default {
  components: {
    ApiErrorAlert,
    BrokerSearch,
    BrokerAlert,
    InfoIcon,
  },
  props: {
    myImport: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    errorCode: null,
    brokerSearchBrokers: [],
    brokerSearchLoading: false,
    importType: 'generic',
    checkDuplicates: true,
    createBuysFromExternalTransfers: false,
  }),
  computed: {
    ...mapState(['user']),
    showCard() {
      return !this.myImport.status
    },
    saveDisabled() {
      return (
        !this.myImport.broker ||
        (this.importType !== 'generic' && !this.isValidBroker) ||
        !this.myImport.file ||
        this.fileSizeExceeded
      )
    },
    isValidBroker() {
      return (
        this.myImport.broker &&
        getSupportedBrokersForImport(this.type).indexOf(this.myImport.broker.code) > -1
      )
    },
    fileSize() {
      return this.myImport && this.myImport.file && this.myImport.file.size
    },
    fileSizeExceeded() {
      return this.fileSize && this.fileSize > Math.pow(10, 6)
    },
    isBrokerInBeta() {
      if (!this.myImport.broker) return false
      return isBrokerInBetaForImport({ code: this.myImport.broker.code })
    },
    isBrokerCheckingDuplicates() {
      if (!this.myImport.broker) return false
      if (this.importType === 'generic') return false
      return isBrokerCheckingDuplicates({ type: this.type, code: this.myImport.broker.code })
    },
    isBrokerCreateBuysFromExternalTransfers() {
      if (!this.myImport.broker) return false
      if (this.importType === 'generic') return false
      return isBrokerCreateBuysFromExternalTransfers({
        type: this.type,
        code: this.myImport.broker.code,
      })
    },
  },
  watch: {
    isValidBroker() {
      if (this.isValidBroker) this.importType = 'custom'
      else this.importType = 'generic'
    },
    importType() {
      if (this.showCard)
        gtag.pageview({
          pagePath: `/input/${this.type === 'order' ? 'orders' : 'dividends'}/import/selectType`,
          pageTitle: `input|${this.type === 'order' ? 'orders' : 'dividends'}|import|selectType`,
          pageContentGroup: 'modal',
          extraParams: {
            type: this.importType,
          },
        })
    },
  },
  mounted() {
    if (this.isValidBroker) this.importType = 'custom'
    else this.importType = 'generic'
  },
  methods: {
    async importCsv() {
      try {
        this.loading = true
        let type = null
        if (this.importType === 'custom') type = this.type
        else this.type === 'order' ? (type = 'orderGeneric') : (type = 'dividendGeneric')

        const result = await importCsv({
          type,
          broker: this.myImport.broker._id,
          file: this.myImport.file,
          // notCheckDuplicates: !this.checkDuplicates,
          createBuysFromExternalTransfers: this.createBuysFromExternalTransfers,
        })

        this.$emit('update:myImport', result.data)

        gtag.pageview({
          pagePath: `/input/${
            this.type === 'order' ? 'orders' : 'dividends'
          }/import/upload/success`,
          pageTitle: `input|${
            this.type === 'order' ? 'orders' : 'dividends'
          }|import|upload|success`,
          pageContentGroup: 'modal',
          extraParams: {
            broker: this.myImport.broker.code,
          },
        })
      } catch (error) {
        this.errorCode = get(error, 'data.name', null)
        if (!this.errorCode) {
          this.$root.$snackbar.error({ text: this.$t('common.saveError') })
        } else {
          this.$refs.apiErrorAlert.scrollToError()
        }

        gtag.pageview({
          pagePath: `/input/${this.type === 'order' ? 'orders' : 'dividends'}/import/upload/error`,
          pageTitle: `input|${this.type === 'order' ? 'orders' : 'dividends'}|import|upload|error`,
          pageContentGroup: 'modal',
          extraParams: {
            broker: this.myImport.broker.code,
          },
        })
      }
      this.loading = false
    },
    preSelectBroker({ broker }) {
      if (broker && this.brokerSearchBrokers) {
        const brokerInSelect = this.brokerSearchBrokers.find((elem) => elem.value.code === broker)
        if (brokerInSelect) this.$set(this.myImport, 'broker', brokerInSelect.value)
      }
    },
    changeBroker(broker) {
      gtag.pageview({
        pagePath: `/input/${this.type === 'order' ? 'orders' : 'dividends'}/import/selectBroker`,
        pageTitle: `input|${this.type === 'order' ? 'orders' : 'dividends'}|import|selectBroker`,
        pageContentGroup: 'modal',
        extraParams: {
          broker: broker.code,
        },
      })
    },
  },
}
</script>

<style lang="scss">
#import-modal-upload-card {
  p {
    font-size: 15px;
  }

  .list-mode-link {
    font-size: 15px;
    font-weight: 500;
  }

  .import-modal-upload-card-beta-info {
    font-size: 14px;
    a {
      text-decoration: none;
    }
    .v-alert__icon {
      margin-right: 5px;
    }
  }

  .import-modal-upload-card-instructions {
    line-height: 1.7;
    h1 {
      font-size: 15px;
      font-weight: 500;
    }
    ol {
      font-size: 15px;
    }
  }
  .import-modal-upload-card-dividend-info {
    font-size: 15px;
    font-weight: 400;
  }

  .more-configuration-link {
    font-size: 13px;
  }

  .switch-option {
    .v-label {
      font-size: 14px;
      margin-bottom: 2px;
    }
    .v-label--is-disabled {
      color: black;
    }
    .switch-option-text {
      font-size: 12px;
      font-weight: 500;
    }
    .switch-option-icon {
      margin-bottom: 1px;
    }
  }

  .tabs {
    background-color: white;
    .v-tab {
      text-transform: none;
    }
    .v-tab-active-class {
      color: rgba(0, 0, 0, 0.87);
      background-color: #eeeeee;
    }
  }
}

.theme--dark {
  #import-modal-upload-card {
    .tabs {
      background-color: #323940;
      .v-tab-active-class {
        color: white;
        background-color: #3b444c;
      }
      .v-tabs-bar__content {
        background-color: #323940;
      }
    }

    .switch-option {
      .v-label--is-disabled {
        color: white;
      }
    }
  }
}
</style>
